
import Modal from "../../components/rebranding/modal/Modal.vue";

export default {
  components: { Modal },
  data() {
    return { FormTitle: "ثبت درخواست ارتباط با واحد فروش" };
  },
};
